var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"e4s-flex-row e4s-status-pill e4s-pill e4s-justify-flex-center",class:_vm.getPillClass},[_vm._t("default",function(){return [_c('span',{domProps:{"textContent":_vm._s(_vm.text)}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }